import axios from 'axios'
import APP from '@/utils/base'
import { MessageBox, Message, Loading } from 'element-ui'
import { getToken, getUserInfo, removeToken, removeUserInfo, removeEnterToken, removeEnterInfo, removeEnterStatus } from '@/utils/auth'
/* eslint-disable */

// create an axios instance
let loadingInstance = null
let _baseUrl = APP.isTest ? APP.HOST.TEST.EQPT_URL : APP.HOST.OFFICIAL.EQPT_URL // 默认 灿远塔机标定
const service = axios.create({
  baseURL: _baseUrl, // url = base url + request url
  withCredentials: false, // 发送请求时是否携带cookies
  timeout: 30000 // 超时时长
})

service.interceptors.request.use(
  config => {
    config.headers['X-Token'] = getToken()
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // ***start***判断 如果设备号为2开头 把请求域名改为 巨正塔机标定
    if(config.method == 'get'){
      if(config.params.number&&(config.params.number.slice(0,1) == 2)){// 如果有设备号 且 设备号为2开头
        config.baseURL = APP.isTest ? APP.HOST.TEST.EQPT_JZ_URL : APP.HOST.OFFICIAL.EQPT_JZ_URL
      }
    }
    // 塔机 基本设置 + 标定 保存时 操作
    if(config.method == 'post'){
      if(config.url.indexOf('sendCalibrationParam')!=-1 || config.url.indexOf('sendBasicParamConfig')!=-1){
        let _number = config.data.get('number')
        if(_number[0]&&_number[0].slice(0,1)==2){
          config.baseURL = APP.isTest ? APP.HOST.TEST.EQPT_JZ_URL : APP.HOST.OFFICIAL.EQPT_JZ_URL
        }
      }
    }
    // ***end***
    // 是否显示加载框
    if( !config.notLoading ){
      loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,0)',
        spinner: 'el-icon-loading'
      })
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    // 关闭加载框
    if( !response.config.notLoading ){
      loadingInstance.close();
    }
    if (res.code !== 1) {
      //    301001 签名不正确
      //    301002 签名在某个时间段才能用
      //    301003 token过期
      //    301004 其他错误
      //    301006 登录过期
      if (res.code === 301001 || res.code === 301002 || res.code === 301003 || res.code === 301004 || res.code === 301006) {
        // to re-login
        Message.error(res.data)
        removeToken()
        removeUserInfo()
        removeEnterToken()
        removeEnterInfo()
        removeEnterStatus()
        location.reload()
      }
      return Promise.reject(res || 'error')
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    loadingInstance.close();
    Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/requestEqpt.js